import { getPropertyDetailsForLease } from "./api";

export const populatePropertyDetails = async (
    propertyId,
    buildingName,
    unitNo,
    forceRefresh = false,
    existingPropertyDetails = {}
) => {
    if (forceRefresh || !existingPropertyDetails?.partnership_label) {
        const { data: values } = await getPropertyDetailsForLease(propertyId, buildingName);

        if (values) {
            const { property_details, manager } = values;

            const structured_property_details = {
                logo: property_details.logo || "",
                partnership_label: property_details.partnership_label || "",
                landlord: property_details.landlord || "",
                utilities_available: {
                    electricity: property_details.utilities_available?.electricity ?? true,
                    heat: property_details.utilities_available?.heat ?? true,
                    water_waste: property_details.utilities_available?.water_waste ?? true,
                },
                pet_fees: {
                    cat_fee: property_details.pet_fees?.cat_fee ?? false,
                    dog_fee: property_details.pet_fees?.dog_fee ?? false,
                    other_fee: property_details.pet_fees?.other_fee ?? false,
                },
                allowed_pets: {
                    dogs: property_details.allowed_pets?.dogs ?? false,
                    cats: property_details.allowed_pets?.cats ?? false,
                    others: property_details.allowed_pets?.others ?? false,
                },
                property_name: property_details.property_name || "",
                building_name: property_details.building_name || buildingName || "",
                unit_no: property_details.unit_no || unitNo || "",
                address: property_details.address || "",
                city: property_details.city || "",
                province: property_details.province || "",
                postal_code: property_details.postal_code || "",
                appliances: Array.isArray(property_details.appliances)
                    ? property_details.appliances
                    : property_details.appliances
                        ? [property_details.appliances]
                        : [],
            };

            const manager_details = manager
                ? {
                    first_name: manager.first_name || "",
                    last_name: manager.last_name || "",
                    phone_no: manager.phone_no || "",
                    email: manager.email || "",
                    signature: manager.signature || "",
                    date: new Date().toISOString().split("T")[0],
                }
                : null;

            return {
                property_details: structured_property_details,
                manager: manager_details,
            };
        }
    }

    return null;
};